module.exports = __webpack_public_path__ + "static/media/other-viola.c6e4e7ec.mp3";